import React, { useCallback, useMemo } from "react";
import { connect } from "react-redux";
import axios from "axios";
import notify from "devextreme/ui/notify";
import { Button } from "devextreme-react/button";
import FormField from "../../dynamicFormBuilder/FormField";
import { DetailUserDefinedLayout } from "./Layout";
import { GetFormatedDateWithTime } from "../../common/Utils";
import { CONCURRENCY_HANDLED, getApiErrorMessage } from "../../common/concurrency";
import data from "../../assets/apiRoutes.json";
import { EMPTY_GUID } from "../../const/constants";

const ROUTES = data.IM.ItemManagement;
const RANGE5 = [1, 2, 3, 4, 5];

// Details -> "User Defined" sub-tab (Delphi uIMD0019 Details/User Defined): the SELECTED line's user-defined
// Code/Reference/Date/Quantity 1..5. Editable; Save posts the whole line (UpdateTransactionDetailByRowId).
function DetailUserDefinedTab(props) {
    const currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const accessToken = props.oidc?.user?.access_token;

    const line = props.formFields || {};
    const hasLine = line.rowid && line.rowid !== EMPTY_GUID;
    const editable = hasLine && !props.disabled;

    const finalLayout = useMemo(() => DetailUserDefinedLayout, []);

    const handleSelectionChange = useCallback((name, value, e) => {
        if (props.handleFieldChange) props.handleFieldChange(name, value, e);
    }, [props.handleFieldChange]);

    const handleFormLoad = useCallback(() => {}, []);

    const save = useCallback(() => {
        if (!hasLine) { notify("Select a detail line first.", "warning", 3000); return; }
        // Post the whole line as JSON (same flow as the Accounting sub-tab); format the date fields.
        const payload = { ...line, transactionDate: line.transactionDate ? GetFormatedDateWithTime(line.transactionDate) : null };
        RANGE5.forEach((i) => { payload[`date${i}`] = line[`date${i}`] ? GetFormatedDateWithTime(line[`date${i}`]) : null; });
        axios.post(`${window._env_.REACT_APP_APIS}/${ROUTES.UpdateTransactionDetailByRowId}`, payload, {
            headers: {
                access_token: accessToken,
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
        }).then((res) => {
            notify("User defined saved.", "success", 3000);
            if (props.onSaved) props.onSaved(res.data);
        }).catch((err) => {
            if (err?.[CONCURRENCY_HANDLED]) return;
            notify(getApiErrorMessage(err, "Failed to save user defined."), "error", 5000);
        });
    }, [hasLine, line, accessToken, props]);

    if (!hasLine) {
        return <div style={{ padding: 16, color: "#888" }}>Select a detail line to view or edit its user-defined fields.</div>;
    }

    return (
        <div>
            <div style={{ textAlign: "right", marginBottom: 4 }}>
                <Button text="Save" type="default" onClick={save} disabled={!editable} />
            </div>
            {/* The 4x5 grid of fields is taller than the sub-tab area; make it scroll on its own. */}
            <div style={{ maxHeight: "34vh", overflowY: "auto", paddingRight: 8 }}>
                <FormField
                    currrentUser={currentUser}
                    layoutId="7743D0EF-E1A0-42DB-82AE-426EC31F7E28"
                    layoutName="IMTransactionEntryDetailUserDefinedForm"
                    defaultFormSchema={finalLayout}
                    formFields={props.formFields}
                    setformFields={props.setformFields}
                    handleFieldValueChange={handleSelectionChange}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={props.formRefs}
                    onFormLoad={handleFormLoad}
                />
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return { oidc: state.oidc };
}

export default connect(mapStateToProps)(DetailUserDefinedTab);
